import {HashLink} from 'react-router-hash-link'
import styled from 'styled-components'
import {linkCss} from './A'

export default styled(HashLink)`
${linkCss}
`



// WEBPACK FOOTER //
// ./src/shared/HashLink.js